import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const SmartIndiaHackathon202526 = () => {
    const workshopImages = [
        "hackathon1.JPG ",
        "hackathon2.JPG ",
        "hackathon3.JPG",
    ];


    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2>
                                        SMART INDIA HACKATHON 2025-26
                                    </h2>
                                    <div className='py-2'>
                                        <p>
                                            An Internal Hackathon was held at Sridevi Women’s Engineering College, Vattinagulapally, on 22nd September to select teams for SIH. Various teams presented different project ideas. The event was split into different phases. Each team consisted of 6 members. The 1st phase contains a presentation about the project in front of the jury. The whole process was seamless and kept the students more engaged, encouraged, and confident. Finally, 10 teams got selected for the next round.
                                        </p>
                                    </div>
                                    <h4>SELECTED TEAM NAMES:</h4>
                                    <ul>
                                        <li>ManaVerse</li>
                                        <li>Bit Stromers</li>
                                        <li>Next Gencoders</li>
                                        <li>Code Crusaders</li>
                                        <li>Runtime Terror</li>
                                        <li>Zefinyx</li>
                                        <li>Path Minds</li>
                                        <li>LactoTech</li>
                                        <li>Routex</li>
                                    </ul>


                                    <div className="css-script-ads"></div>
                                    <div className="spotlight-group">

                                        <div className="row">
                                            {workshopImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/Smart-India-Hackathon-2025-26/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/Smart-India-Hackathon-2025-26/${img}`}
                                                            alt={`Smart-India-Hackathon-2025-26  Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default SmartIndiaHackathon202526;
